import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { MultiSelectDropdown } from '../MultiSelectDropdown/MultiSelectDropdown'
import { selectEmailFilterEmailTypeIds, setEmailFilterEmailTypeIds } from '../../store/emailHub/emailFilters'
import { selectEmailTypes, selectEmailTypesLoading } from '../../store/emailHub/emailTypes'

export interface EmailTypeFilterProps {
  disabled?: boolean
}

export const EmailTypeFilter: React.FC<EmailTypeFilterProps> = ({ disabled = false }) => {
  const dispatch = useAppDispatch()

  const emailTypes = useAppSelector(selectEmailTypes)
  const emailTypesLoading = useAppSelector(selectEmailTypesLoading)
  const emailFilterEmailTypeIds = useAppSelector(selectEmailFilterEmailTypeIds)

  const emailTypeOptions = useMemo(() => {
    return emailTypes.map((emailType) => {
      return { id: emailType.id, label: emailType.name }
    })
  }, [emailTypes])

  const handleEmailTypeIdsChanged = (emailTypeIds: string[]) => {
    dispatch(setEmailFilterEmailTypeIds(emailTypeIds))
  }

  return (
    <div className='d-flex flex-column gap-2'>
      <div className='lead-extra-small'>Filter by email type {emailFilterEmailTypeIds.length ? `(${emailFilterEmailTypeIds.length})` : null}</div>

      <MultiSelectDropdown
        name='emailTypeIds'
        options={emailTypeOptions}
        initialSelectedOptions={emailFilterEmailTypeIds}
        onSelectedChanged={handleEmailTypeIdsChanged}
        disabled={disabled || emailTypesLoading}
      />
    </div>
  )
}
